import * as polyfillAssign from 'es6-object-assign';
import {polyfill} from 'es6-promise';

polyfill(); // es6-promise polyfill
polyfillAssign.polyfill();  // es6-object-assign polyfill

//IE11 doesn't support Math.trunc
Math.trunc = Math.trunc || function(x) {
    return x - x%1;
};



// WEBPACK FOOTER //
// ./resources/modules/shared/polyfills.ts